import { ICancelarPagamentoUseCase } from "../../../presentation/useCases/update/cancelar_pagamento_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CancelarRecebimentoUseCase
 */

export class CancelarPagamentoUseCase implements ICancelarPagamentoUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async cancelarPagamento(idContasPagar: number): Promise<void> {
    await this.repository.cancelarPagamento(idContasPagar);

  }
}
